var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { setClassNamesMiniCard, getMarkets } from "../../../../helpers";
import { MiniMarketsWrap } from "../MiniMarketsWrap";
import { MiniCardDetails } from "../MiniCardDetails";
let MiniEventCard = class MiniEventCard extends React.Component {
    render() {
        const details = Object.assign(Object.assign({}, this.props), { markets: getMarkets(this.props.sport.config.markets, this.props.markets, this.props.event) });
        const classNames = setClassNamesMiniCard(details.event.isSelected, details.event.isInKickOffState, "mini-ev-card");
        return (React.createElement("div", { className: `rj-ev-list__mini-ev-card ${classNames}`, "data-uat": "div-ev-list-mini-ev-card" },
            React.createElement("div", { className: "rj-ev-list__mini-ev-card__inner", "data-uat": "div-ev-list-mini-ev-card-inner" },
                React.createElement(MiniCardDetails, { details: details, componentPrefix: "mini-ev-card" }),
                this.props.showOddBtns &&
                    React.createElement(MiniMarketsWrap, { details: details, componentPrefix: "mini-ev-card" }))));
    }
};
MiniEventCard = __decorate([
    observer
], MiniEventCard);
export { MiniEventCard };
//# sourceMappingURL=MiniEventCard.js.map